// import React, { useState, useEffect } from "react";
// import {
//   Avatar,
//   Card,
//   CardContent,
//   Grid,
//   Typography,
// } from "@mui/material";

// import { orange } from "@mui/material/colors";
// import AllOutIcon from "@mui/icons-material/AllOut";

// const Budget = (props) => {
//   const [labscard, setLabscard] = useState([]);

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_API_URL}/api/labscard/`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + localStorage.getItem("token"),
//       },
//     })
//       .then((resp) => resp.json())
//       .then((data) => {
//         setLabscard(data);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, []);

//   return (
//     <Card sx={{ height: "100%" }} {...props}>
//       <CardContent>
//         <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
//           <Grid item>
//             <Typography color="textSecondary" gutterBottom variant="h6">
//               TOTAL LABS
//             </Typography>
//             <Typography color="textPrimary" variant="h3">
//               {labscard.total}
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Avatar
//               sx={{
//                 backgroundColor: orange[600],
//                 height: 56,
//                 width: 56,
//               }}
//             >
//               <AllOutIcon />
//             </Avatar>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );
// };

// export default Budget;



import React from "react";
import { Card, Avatar, CardContent, Grid, Typography } from "@mui/material";
import { orange } from "@mui/material/colors";
import AllOutIcon from "@mui/icons-material/AllOut";

const TotalApplications = ({ value }) => (
  <Card>
    <CardContent>
      <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h6">
            TOTAL LABS
          </Typography>
          <Typography color="textPrimary" variant="h3">
            {value || 0} {/* Handle undefined initial state */}
          </Typography>
        </Grid>
        <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56,
              }}
            >
              <AllOutIcon />
            </Avatar>
          </Grid>
      </Grid>
    </CardContent>
  </Card>
);
export default TotalApplications;